module.exports = __webpack_public_path__ + "media/flags/pe-935d1c42.svg";